// ============================================
// components/common/Layout.js
// ============================================
import React from 'react';
import { AppBar, Toolbar, Typography, Button, Container, IconButton } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { authService } from '../../services/authService';
import { ROUTES } from '../../utils/constants';
import HomeIcon from '@mui/icons-material/Home';

const Layout = ({ children, title = 'Porchlight', showLogout = false, showBack = false, backTo = '/' }) => {
  const navigate = useNavigate();

  const handleLogout = async () => {
    const result = await authService.logout();
    if (result.success) {
      navigate(ROUTES.LOGIN);
    }
  };

  return (
    <>
      <AppBar position="static">
        <Toolbar>
          {showBack && (
            <IconButton
              color="inherit"
              edge="start"
              onClick={() => navigate(backTo)}
              sx={{ mr: 1 }}
              aria-label="Go to home"
            >
              <HomeIcon />
            </IconButton>
          )}
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            {title}
          </Typography>
          {showLogout && (
            <Button color="inherit" onClick={handleLogout}>
              Logout
            </Button>
          )}
        </Toolbar>
      </AppBar>
      <Container>
        {children}
      </Container>
    </>
  );
};

export default Layout;